import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalculationResult } from 'src/app/Modules/informate/models/calculationModels';
import { UserDefaultModel } from 'src/app/models/user-default-model';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { IdmApiService, ManagementApiService, UserUtilityService } from 'src/app/services';
import { PlantList } from '../../models/plant-manager.model';
import { ReportViewerComponent } from 'src/app/Modules/informate/components/report-viewer/report-viewer.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReportApiService } from 'src/app/services/report.api.service';
import { Subject, takeUntil } from 'rxjs';
import { DataSheetReport } from 'src/app/Modules/informate/models/reports/data-sheet-report.model';
import { JointCompletionCertificate } from 'src/app/Modules/informate/models/reports/joint-completion-certificate.model';
import { ProjectActivityPackDetails } from '../../../project-manager/models/ProjectActivityPackDetails.model';

@Component({
    selector: 'app-print-reports',
    templateUrl: './print-reports.component.html',
    styleUrls: ['./print-reports.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PrintReportsComponent implements OnInit, OnDestroy {
    @Input() calculationResult: CalculationResult;
    @Input() TaggedItemData: PlantList;
    @Input() barCodeNumber: string;
    @Input() Type: string;
    @Input() activityPackDetails: ProjectActivityPackDetails;
    destroy$ = new Subject();

    userDefaults: UserDefaultModel[];
    reportData: DataSheetReport | JointCompletionCertificate | DataSheetReport[] | JointCompletionCertificate[];

    constructor(
        private modalService: NgbModal,
        private globalEmittersService: GlobalEmittersService,
        private managementApiService: ManagementApiService,
        private elementRef: ElementRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private reportApiService: ReportApiService,
        private user_utlity: UserUtilityService,
        private idmApiService: IdmApiService
    ) {}

    ngOnInit(): void {
        this.globalEmittersService.isUserDefaultsLoaded.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.userDefaults = this.managementApiService.userDefaults;
            }
        });
    }

    ngAfterViewInit(): void {
        this.applyStylesBasedOnScreenSize();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        this.applyStylesBasedOnScreenSize();
    }

    applyStylesBasedOnScreenSize() {
        const element = this.elementRef.nativeElement.querySelector('.dropdown-menu-md');
        // if (window.innerWidth < 1000) {
        //     element.classList.remove('dropdown-menu-custom');
        //     element.classList.remove('dropdown-menu-custom1');
        //     element.classList.remove('dropdown-menu-custom2');
        //     element.classList.remove('dropdown-menu-custom3');
        //     element.classList.remove('dropdown-menu-custom4');
        //     element.classList.add('dropdown-menu-custom4');
        // } else if (window.innerWidth < 1200) {
        //     element.classList.remove('dropdown-menu-custom');
        //     element.classList.remove('dropdown-menu-custom1');
        //     element.classList.remove('dropdown-menu-custom2');
        //     element.classList.remove('dropdown-menu-custom3');
        //     element.classList.remove('dropdown-menu-custom4');
        //     element.classList.add('dropdown-menu-custom3');
        // } else if (window.innerWidth < 1400) {
        //     element.classList.remove('dropdown-menu-custom');
        //     element.classList.remove('dropdown-menu-custom1');
        //     element.classList.remove('dropdown-menu-custom2');
        //     element.classList.remove('dropdown-menu-custom3');
        //     element.classList.remove('dropdown-menu-custom4');
        //     element.classList.add('dropdown-menu-custom2');
        //     // Apply other styles for smaller screens
        // } else if (window.innerWidth < 1600) {
        //     element.classList.remove('dropdown-menu-custom');
        //     element.classList.remove('dropdown-menu-custom1');
        //     element.classList.remove('dropdown-menu-custom2');
        //     element.classList.remove('dropdown-menu-custom3');
        //     element.classList.remove('dropdown-menu-custom4');
        //     element.classList.add('dropdown-menu-custom1');
        // } else {
        //     element.classList.remove('dropdown-menu-custom');
        //     element.classList.remove('dropdown-menu-custom1');
        //     element.classList.remove('dropdown-menu-custom2');
        //     element.classList.remove('dropdown-menu-custom3');
        //     element.classList.remove('dropdown-menu-custom4');
        //     element.classList.add('dropdown-menu-custom');
        // }
        // this.cd.detectChanges();
    }

    openCreateDataSheetModal() {
        let payload: any = { criteria: [{ TaggedItemId: this.TaggedItemData.taggedItemId }] };
        // this.getReportApiCall('JointDataSheetReport', payload, 'getdatasheet');
        this.callReports('JointDataSheetReport', payload, 'getdatasheet');
    }

    openITRReport() {
        this.LoadTaggedItemForEdit();
    }

    openCreatePackSheet() {
        try {
            this.ngxUiLoaderService.start();
            let payLoad = {
                activityPackIds: [this.activityPackDetails.activityPackId],
            };
            this.reportApiService.getpacksheet(payLoad).subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success) {
                        this.ngxUiLoaderService.start();
                        let rptData = {
                            ReportName: 'PackSheetReport',
                            PackSheetData: res.response,
                            Formate: 'pdf',
                        };
                        this.reportApiService.exportReport(rptData).subscribe((response) => {
                            const blob = new Blob([response], { type: 'application/pdf' });
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');

                            window.open(url, '_blank');
                            setTimeout(() => window.URL.revokeObjectURL(url), 1000);

                            this.ngxUiLoaderService.stop();
                        });
                    } else {
                        this.user_utlity.errorModelPopup(res.message);
                    }
                },
                (err) => this.ngxUiLoaderService.stop()
            );
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err);
        }
    }

    callReports(reportName: string, reportData, reportType: string) {
        this.ngxUiLoaderService.start();
        this.reportApiService
            .getReport(reportData, reportType)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (resp) => {
                    if (resp.success) {
                        this.reportData = resp.response;
                        this.getReportData(reportName, reportData, reportType);
                    } else {
                        this.user_utlity.errorModelPopup(resp.message);
                    }
                    this.ngxUiLoaderService.stop();
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    async getReportData(reportName: string, reportData, reportType: string) {
        if (localStorage.getItem('currentInstanceTypeName').toLowerCase() == 'idms') {
            try {
                let res = await this.managementApiService.getSettingProfileAreaId('iDMS').toPromise();

                if (res.success) {
                    let settingArea = res.response;

                    let _res = await this.managementApiService
                        .getInstanceDefaultSettings(settingArea.settingAreaId, localStorage.getItem('currentInstanceId'))
                        .toPromise();

                    if (_res.success) {
                        var InstanceSettings = _res.response;
                        if (InstanceSettings) {
                            // Find the setting with key "ReportQRCode_Visible"
                            const setting = InstanceSettings.find((item) => item.userPreferenceKey === 'ReportBarcode_Visible');

                            // Extract the "value" from "settingValue" if found
                            const isBarcodeVisible = setting?.userPreference;
                            // Find the setting with key "ReportQRCode_Visible"
                            const _setting = InstanceSettings.find((item) => item.userPreferenceKey === 'ReportQRCode_Visible');

                            // Extract the "value" from "settingValue" if found
                            const isQRcodeVisible = _setting?.userPreference;
                            const isQRVisible = isQRcodeVisible.toLowerCase() === 'true';
                            const isBarcodeVisibleFlag = isBarcodeVisible.toLowerCase() === 'true';

                            if (Array.isArray(this.reportData)) {
                                // Case: Array of rows
                                this.reportData.forEach((row) => {
                                    row.isQRcodeVisible = isQRVisible;
                                    row.isBarcodeVisible = isBarcodeVisibleFlag;
                                });
                            } else if (this.reportData) {
                                // Case: Single object
                                this.reportData['isQRcodeVisible'] = isQRcodeVisible.toLowerCase() == 'true' ? true : false;
                                this.reportData['isBarcodeVisible'] = isBarcodeVisible.toLowerCase() == 'true' ? true : false;
                            }

                            try {
                                this.ngxUiLoaderService.start();
                                let rptData = {
                                    ReportName: reportName,
                                    DatasheetReportData: this.reportData[0],
                                    JointCompletionCertificateData: this.reportData[0],
                                    ITRReport: this.reportData[0],
                                    Formate: 'pdf',
                                };
                                this.reportApiService.exportReport(rptData).subscribe((response) => {
                                    const blob = new Blob([response], { type: 'application/pdf' });
                                    const url = window.URL.createObjectURL(blob);
                                    const a = document.createElement('a');

                                    window.open(url, '_blank');
                                    setTimeout(() => window.URL.revokeObjectURL(url), 1000);

                                    this.ngxUiLoaderService.stop();
                                });
                                //  }
                            } catch (err) {
                                this.ngxUiLoaderService.stop();
                                this.user_utlity.errorModelPopup('Error');
                            }
                        }
                    }
                }
            } catch (e) {
                this.ngxUiLoaderService.stop();
            }
        }
    }

    getReportApiCall(reportName: string, reportData, reportType: string) {
        this.ngxUiLoaderService.start();
        this.reportApiService
            .getReport(reportData, reportType)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (resp) => {
                    if (resp.success) {
                        let dialogRef = this.modalService.open(ReportViewerComponent, {
                            size: 'xl',
                            windowClass: 'bg-grey',
                            backdrop: 'static',
                            keyboard: false,
                        });
                        dialogRef.componentInstance.reportData = resp.response;
                        dialogRef.componentInstance.reportName = reportName;
                        reportName = '';
                    } else {
                        this.user_utlity.errorModelPopup(resp.message);
                    }
                    this.ngxUiLoaderService.stop();
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    async LoadTaggedItemForEdit() {
        await this.idmApiService
            .GetTaggedItemDataById(this.TaggedItemData.taggedItemId)
            .toPromise()
            .then((res) => {
                if (res.success === true) {
                    if (res.response) {
                        let ActivityPackData = res.response?.activityPacks;
                        let criteria = [];
                        if (ActivityPackData) {
                            ActivityPackData.forEach((element) => {
                                let data = { activityPackId: element?.activityPackId, taggedItemId: this.TaggedItemData.taggedItemId };
                                criteria.push(data);
                            });
                        }

                        let payload: any = { criteria: criteria };
                        this.getReportApiCall('ITRReport', payload, 'getitr');
                    }
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
